import React, { Component } from 'react'
import Radium, { keyframes } from 'higher-order-components/configured-radium/'
import flash from 'react-animations/lib/flash'

const flashKeyFrame = keyframes({
  from: {
    opacity: 1
  },
  '70%': {
    opacity: 0,
  },
  to: {
    opacity: 0
  }
})

class TimeComponent extends Component {
  constructor() {
    super()
    this.state = {
      now: new Date()
    }
  }

  componentDidMount() {
    setInterval(() => {
      this.setState({
        now: new Date()
      })
    }, 1000)
  }

  getHours12 = (date) => {
    return (date.getHours() + 24) % 12 || 12;
  }

  render() {
    const TimeStyles = {
      time: {
        fontFamily: 'dseg7',
        textAlign: 'center',
        fontSize: '225%',
        transform: 'translate(-12%,-35%)',
        fontStyle: 'italic',
        letterSpacing: '0.18em',
        opacity: '0.5',
        color: '#ff2a3a',
        textShadow: '#ff2a3a 0px 0px 30px'
      },
      backTime: {
        position: 'absolute',
        opacity: 0.5,
        color: '#5f151f',
        zIndex: '-1',
        textShadow: '0px 0px 10px #4f010c'
      },
      dots: {
        animation: 'x 1s infinite',
        animationName: flashKeyFrame
      }
    }
    // if we want the blinking effect, will need to rewrite.

    const hours = String(this.getHours12(this.state.now))
    const mins = (Number(this.state.now.getMinutes()) < 10 ? '0' : '') + String(this.state.now.getMinutes())
    return (
      <div style={TimeStyles.time}>
        <div style={TimeStyles.backTime}>
          <span>
            88
          </span>
          <span>:</span>
          <span>
            88
          </span>
        </div>
        <div>
          <span style={{visibility: 'collapse'}}>
            {Number(this.getHours12(this.state.now)) < 10 ? '0' : ''}
          </span>
          <span>
            {hours}
          </span>
          <span style={TimeStyles.dots}>:</span>
          <span>
            {mins}
          </span>
        </div>
      </div>
    )
  }
}

export default Radium(TimeComponent)



// WEBPACK FOOTER //
// ./src/components/time-component/index.jsx